(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function toggleMenu() {
    const menu = document.getElementById('mobileMenu');
    const toggle = document.querySelector('[data-menu-toggle]');
    if (!menu) return;

    const isOpen = menu.classList.toggle('is-open');
    menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    }
  }

  window.toggleMenu = toggleMenu;

  document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('[data-menu-toggle]');
    if (toggle) {
      toggle.addEventListener('click', toggleMenu);
    }

    const menu = document.getElementById('mobileMenu');
    if (menu) {
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
          menu.classList.remove('is-open');
          menu.setAttribute('aria-hidden', 'true');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Open menu');
          }
        });
      });
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768 && menu) {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Open menu');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
